import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.columnGroups', {
    lineItemFieldText: 'Line items data',
    keyDataText: 'Key data',
    workflowText: 'Workflow',
    complianceText: 'Compliance',
    matchingText: 'Matching',
    poDetailsText: 'Purchase Order details',
    quoteDetailsText: 'Quote details',
    billDetailsText: 'Bill details',
    expenseDetailsText: 'Expense details',
    salesInvoiceDetailsText: 'Sales invoice details',
    creditNotesPayableDetailsDetailsText: 'AP Credit Note details',
    standaloneWorkflowFieldsText: 'Stand-alone details',
    grnStatusFieldText: 'Goods received note status',
    journalEntryDetailsText: 'Journal Entry details',
});
